import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { DatePicker } from 'syngenta-digital-cropwise-react-ui-kit';
import PersonFieldLabel from '../../../PersonFieldLabel';

const toMoment = expiration => {
  if (!expiration) {
    return null;
  }
  const date = moment(expiration);
  return date.isValid() ? date : null;
};

// The licence stores the expiry as epoch milliseconds at local midnight, as
// grow-ui's flatpickr emitted it, or an empty string when cleared.
const toExpiry = date =>
  date
    ? date
        .clone()
        .startOf('day')
        .valueOf()
    : '';

function ExpirationField({ expiration = null, onChange, title = '' }) {
  return (
    <div className="my-4 w-full">
      <div data-testid="expirationField" className="flex">
        <div className="w-full ml-6">
          <PersonFieldLabel htmlFor="expiry-date-picker">
            {title}
          </PersonFieldLabel>
          <div className="block text-sm font-medium leading-5 text-gray-700 sm:mt-px sm:pt-2 w-full">
            <DatePicker
              id="expiry-date-picker"
              name="expiry"
              className="w-full"
              format="MMM DD, YYYY"
              value={toMoment(expiration)}
              onChange={date => onChange(toExpiry(date))}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

ExpirationField.propTypes = {
  expiration: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.instanceOf(Date)
  ]),
  onChange: PropTypes.func.isRequired,
  title: PropTypes.string
};
export default ExpirationField;
